import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CitywireInternalAccountsGuard } from '@tpapa/citywire-internal-accounts-angular';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [CitywireInternalAccountsGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentManagementRoutingModule {}
